export default "__VITE_ASSET__Ctu822Tb__"